import { Route, Routes } from "react-router-dom";
import AmbassadorLayout from "../components/layouts/ambassador-layout";
import AmbassadorHome from "../containers/ambassador/ambassador-home";
import AmbassadorProfile from "../containers/ambassador/ambassador-profile";
import AmbassadorWelcome from "../containers/ambassador/ambassador-welcome";
import AmbassadorGeneralSettings from "containers/ambassador/general-settings";
import AmbassadorExperiences from "containers/ambassador/experiences";
import AmbassadorExperiencesDetail from "containers/ambassador/experience-details";
import AmbassadorResourceLibrary from "containers/ambassador/resource-library";
import AmbassadorFamilyprofile from "containers/ambassador/family-profile";
import AmbassadorEditProfile from "containers/ambassador/edit-profile";
import MyBadges from "containers/ambassador/my-badges";
import Wallet from "containers/ambassador/wallet";
import AmbassadorExperiencesFollow from "containers/ambassador/family-profile/components/experiences";
import AmbassadorJoinExperiences from "containers/ambassador/family-profile/components/join-experiences";
import AmbassadorExperiencesView from "containers/ambassador/ambassador-experience-detail";
import AmbassadorCommunity from "containers/ambassador/communities";
import RedeemPrizePoints from "containers/ambassador/redeem-prize-points";

const AmbassadorRoutes = () => {
  return (
    <AmbassadorLayout>
      <Routes>
        <Route path="/home" element={<AmbassadorHome />} />
        <Route path="/profile" element={<AmbassadorProfile />} />
        <Route path="/edit-profile" element={<AmbassadorEditProfile />} />
        <Route path="/welcome" element={<AmbassadorWelcome />} />
        <Route path="/general-settings" element={<AmbassadorGeneralSettings />} />
        <Route path="/experiences" element={<AmbassadorExperiences />} />
        <Route path="/experiences-details" element={<AmbassadorExperiencesDetail />} />
        <Route path="/resource-library" element={<AmbassadorResourceLibrary />} />
        <Route path="/redeem-prize-points" element={<RedeemPrizePoints />} />
        <Route path="/family-profile" element={<AmbassadorFamilyprofile />} />
        <Route path="/my-badges" element={<MyBadges />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/follow-up-experiences" element={<AmbassadorExperiencesFollow />} />
        <Route path="/join-events" element={<AmbassadorJoinExperiences />} />
        <Route path="/communities" element={<AmbassadorCommunity />} />
        <Route path="/admin-experience-detail" element={<AmbassadorExperiencesView />} />
      </Routes>
    </AmbassadorLayout>
  );
};

export default AmbassadorRoutes;
